import React from 'react';
import { DocumentStatus } from '@alucio/aws-beacon-amplify/src/models';
import { DNABox, DNACard, DNAText, Iffy, useTheme } from '@alucio/lux-ui';
import {
  CommonIcon,
  DNAChip,
  DNACustomFieldChipList,
  DNADocumentStatusChip,
  DNADocumentThumbnail,
  DNARowsComponent,
} from 'src/components/DNA';
import { DocumentVersionORM, FolderItemORM } from 'src/types/types';
import { detectArchivedFileKeyPath } from 'src/components/SlideSelector/useThumbnailSelector';

const DNADocumentFolderItemVirtualRow: DNARowsComponent<FolderItemORM> = (props) => {
  const { ORM: folderItemORM, onPress, style } = props
  const theme = useTheme()
  /** TODO: refactor improper use of as assertion */
  const documentVersionORM = folderItemORM.relations.itemORM as DocumentVersionORM
  const parentDocumentORM = documentVersionORM.relations.documentORM
  const title = folderItemORM.model.customTitle || documentVersionORM.model.title
  const canPresent = parentDocumentORM.meta.permissions.MSLPresent
  const { visiblePages } = folderItemORM.model
  const isModified = (
    visiblePages?.length &&
    documentVersionORM.meta.permissions.MSLSelectSlides &&
    documentVersionORM.model.status === 'PUBLISHED'
  )

  const isArchived = documentVersionORM.meta.sealedStatus === DocumentStatus.ARCHIVED

  const containerStyle = [
    {
      paddingLeft: 12,
      paddingRight: 20,
      paddingVertical: 12,
      backgroundColor: theme['color-dark-300'],
      marginVertical: 1,
      borderRadius: 4,
    },
    style,
  ]

  // If the publisher's selected cover page was hidden by the user
  // we use the first visible page
  // [TODO-2126] - We should be able calculate this at the ORM level instead
  let customThumbnailKey: string | undefined
  const selectedThumbnail = documentVersionORM.model.selectedThumbnail ?? 1
  if (folderItemORM.model.visiblePages && !folderItemORM.model.visiblePages.find(vp => vp === selectedThumbnail)) {
    const customPage = documentVersionORM.meta.allPages[folderItemORM.model.visiblePages[0] - 1]
    customThumbnailKey = detectArchivedFileKeyPath(documentVersionORM.model, customPage)
  }

  return (
    <DNACard
      appearance="flat"
      interactive="pressable"
      onPress={() => { onPress?.(folderItemORM) }}
      style={containerStyle}
    >
      <DNABox alignY="center" style={!canPresent && { opacity: 0.4 }} spacing="between" childFill={0}>
        <DNABox spacing="lg" alignY="center" childFill={1}>
          <DNABox style={{ backgroundColor: 'rgb(0, 0, 0)' }}>
            <DNADocumentThumbnail.Hover
              documentVersionORM={documentVersionORM}
              customThumbnailKey={customThumbnailKey}
              width={126}
              height={72}
            />
          </DNABox>
          <DNABox spacing="sm" fill childFill={0}>
            <DNABox spacing="sm" appearance="col" fill>
              <DNAText b2 colorMode="dark" numberOfLines={1}>
                {title}
              </DNAText>
              <DNABox spacing="sm">
                <DNACustomFieldChipList documentVersionORM={documentVersionORM} />
                <Iffy is={isArchived}>
                  <DNADocumentStatusChip documentStatus={DocumentStatus.ARCHIVED} />
                </Iffy>
                <Iffy is={isModified}>
                  <DNAChip.Beacon variant="MODIFIED" />
                </Iffy>
              </DNABox>
            </DNABox>

            <Iffy is={parentDocumentORM.meta.bookmark.isBookmarked}>
              <CommonIcon variant="document-row-bookmarked" />
            </Iffy>
          </DNABox>
        </DNABox>
      </DNABox>
    </DNACard>
  )
}

export default DNADocumentFolderItemVirtualRow
